module.exports = __webpack_public_path__ + "static/media/penRed.76ddc206.svg";